import { useEffect, useRef } from 'react';

// A soft highlight halo that follows the cursor across the app (like the moving sheen on the
// Configurator gallery). Fixed, pointer-events:none, rAF-throttled. Desktop only (pointer:fine)
// and disabled under prefers-reduced-motion.
export function CursorHalo() {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof window.matchMedia !== 'function') return;
    if (!window.matchMedia('(pointer: fine)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let raf = 0;
    let x = 0;
    let y = 0;
    const apply = () => {
      raf = 0;
      el.style.setProperty('--hx', `${x}px`);
      el.style.setProperty('--hy', `${y}px`);
      el.classList.add('on');
    };
    const onMove = (e: PointerEvent) => {
      x = e.clientX;
      y = e.clientY;
      if (!raf) raf = requestAnimationFrame(apply);
    };
    const onLeave = () => el.classList.remove('on');
    window.addEventListener('pointermove', onMove, { passive: true });
    document.addEventListener('pointerleave', onLeave);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('pointermove', onMove);
      document.removeEventListener('pointerleave', onLeave);
    };
  }, []);
  return <div className="cursor-halo" ref={ref} aria-hidden="true" />;
}
